import {inject, Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {CurrentUserResponse} from '../../models/current-user.model';

@Injectable({
  providedIn: 'root',
})

export class UserService {

  authUrl = environment.authUrl;
  baseUrl = environment.serverUrl + '/corporate-clients';

  private http = inject(HttpClient);

  getCurrentUser() {
    return this.http.get<CurrentUserResponse>(`${this.authUrl}/me`);
  }

  getSystemUsers(params: any) {
    return this.http.get(`${this.authUrl}/users/admin`, { params: params });
  }

  getUserById(id: string) {
    return this.http.get(`${this.authUrl}/users/admin/` + id);
  }

  addUser(data: any) {
    return this.http.post(`${this.authUrl}/users/admin`, data);
  }

  editUser(id: string, data: any) {
    return this.http.put(`${this.authUrl}/users/admin/` + id, data);
  }

  deleteUser(id: string) {
    return this.http.delete(`${this.authUrl}/users/admin/` + id);
  }

  resendPassword(id: any) {
    return this.http.post(this.authUrl + '/users/admin/' + id + '/resend-password-link', {});
  }

}
